document.addEventListener("DOMContentLoaded", () => {
  const defaultCurrencySymbol = "Kč";
  const defaultCurrencyISO = "CZK";

  function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  function setLoadingAnimation(button, duration) {
    const originalContent = button.innerHTML;

    button.classList.add("loading");
    button.innerHTML = "";

    const spinner = document.createElement("div");
    spinner.className = "spinner";
    button.appendChild(spinner);

    setTimeout(() => {
      button.classList.remove("loading");
      button.innerHTML = originalContent;
    }, duration);
  }

  const urlPath = window.location.origin;
  let currencySymbol = defaultCurrencySymbol;

  if (urlPath.includes(".sk") || urlPath.includes(".com")) {
    currencySymbol = "€";
  }

  let currencyISO = defaultCurrencyISO;

  if (urlPath.includes(".sk") || urlPath.includes(".com")) {
    currencyISO = "EUR";
  }

  function getDivisionFactor() {
      return window.location.href.includes(".cz") ? 121 : 120;
    }

  function addCartItem(item) {
    const cartDrawerContainer = document.querySelector(
      ".drawer--item__container"
    );

    if (!cartDrawerContainer) {
      console.error("Error: Cart drawer container not found.");
      return;
    }

    const finalPrice = (item.final_line_price / 100).toFixed(2);
    const formattedPrice = formatPrice(Math.floor(finalPrice));

    const cartItem = `
      <div class="drawer--item">
        <div class="drawer--item__box flex-row">
          <div class="drawer--item__image">
            <img
              style="border-radius: 8px;"
              src="${item.image}"
              height="100%"
              width="auto"
            >
          </div>
          <div class="drawer--item__info flex-column justify-spacebetween">
            <div class="drawer--item__info--info flex-column">
              <h5 class="bold b-break--half">${item.product_title}</h5>
              <h7 class="medium b-break--half">Size: ${item.variant_title}</h7>
              <h7 class="medium">Quantity: ${item.quantity}</h7>
            </div>
          </div>
        </div>
        <div class="flex-column">
          <h5 class="bold b-break--one">${formattedPrice} ${currencySymbol}</h5>
        </div>
      </div>
    `;

    cartDrawerContainer.insertAdjacentHTML("beforeend", cartItem);

    const divisionFactor = getDivisionFactor();
    const trackingValue = (item.price / divisionFactor).toFixed(2);

    fbq("track", "AddToCart", {
      content_ids: item.product_id,
      content_type: "product",
      content_category: item.product_type,
      content_name: item.product_title,
      currency: currencyISO,
      value: trackingValue,
    });

    gtag("event", "add_to_cart", {
      currency: currencyISO,
      value: trackingValue,
      items: [
        {
          item_id: item.product_id,
          item_name: item.product_title,
          item_brand: "Botas",
          item_category: item.product_type,
          price: trackingValue,
        },
      ],
    });
  }

  // Function to refresh and open the cart drawer upon product form submission
  function refreshAndOpenDrawer() {
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network error: ${response.status}`);
        }
        return response.json();
      })
      .then((cartData) => {
        const cartDrawerSubtotal = document.querySelector(
          "#cartDrawerSubtotal"
        );
        const cartDrawerContainer = document.querySelector(
          ".drawer--item__container"
        );

        if (!cartDrawerContainer || !cartDrawerSubtotal) {
          console.error("Error: Cart drawer elements not found.");
          return;
        }

        cartDrawerContainer.innerHTML = "";

        cartData.items.forEach((item) => {
          addCartItem(item);
        });

        const subtotalPrice = (cartData.total_price / 100).toFixed(2);
        const formattedSubtotal = formatPrice(Math.floor(subtotalPrice));
        cartDrawerSubtotal.textContent = `${formattedSubtotal} ${currencySymbol}`;

        openDrawer();
      })
      .catch((error) => {
        console.error("Error refreshing and opening the cart drawer:", error);
      });
  }

  // Function to open the drawer without refreshing
  function openDrawer() {
    document
      .querySelector(".cart--drawer__container")
      .classList.add("is--open");
    document.querySelector(".drawer--cart").classList.add("is--open");
    document.querySelector(".drawer--upsell").classList.add("is--open");
    document.body.classList.add("scroll-disabled");
  }

  // Function to close the drawer
  function closeDrawer() {
    document
      .querySelector(".cart--drawer__container")
      .classList.remove("is--open");
    document.querySelector(".drawer--cart").classList.remove("is--open");
    document.querySelector(".drawer--upsell").classList.remove("is--open");
    document.body.classList.remove("scroll-disabled");
  }

  document
    .querySelector("#btn__open--drawer")
    .addEventListener("click", openDrawer);

  document
    .querySelector("#btn__close--drawer")
    .addEventListener("click", closeDrawer);

  const productForm = document.getElementById("product_form");
  productForm.addEventListener("submit", (event) => {
    event.preventDefault();

    const formData = new FormData(productForm);
    const addToCartButton = event.target.querySelector(".buy-button-btn");
    setLoadingAnimation(addToCartButton, 3000);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          refreshAndOpenDrawer();
        } else {
          console.error("Error adding product to cart:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("btn__continue--drawer");

  button.addEventListener("click", function () {
    location.reload();
  });
});
